import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getAdjustedArrivalReasons } from '../api/services/Rides';

export const useAdjustedArrivalReasons = () => {
  return useApiGet<{ data: [string, string][] }>(['adjustedArrivalReasons'], () => getAdjustedArrivalReasons(), {
    enabled: true,
  });
};
